import React, { Component, PropTypes } from 'react';
import shouldPureComponentUpdate from 'react-pure-render/function';
import './Tag.scss';

export default class Tag extends Component {
  static propTypes = {
    onRemove: PropTypes.func,
    children: PropTypes.string,
    id: PropTypes.number,
    onTagClick: PropTypes.func,
    isFullWidth: PropTypes.bool,
  };

  static defaultProps = {
    isFullWidth: false,
  };

  shouldComponentUpdate = shouldPureComponentUpdate;

  handleClick = (event) => {
    const { onTagClick, onRemove, id } = this.props;
    event.preventDefault();

    if (onTagClick) {
      onTagClick(event);
    } else {
      onRemove(id);
    }
  };

  render() {
    const { isFullWidth } = this.props;

    return (
      <div className={`tag ${isFullWidth && 'tag--full-width'}`}>
        <a href="#" onClick={this.handleClick} className="tag__link">
          <span className={`tag__label ${isFullWidth && 'tag__label--full-width'}`}>{this.props.children}</span>
          <i className={`icon-close ${isFullWidth && 'icon-close--full-width'}`}><span>Close</span></i>
        </a>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Tag/Tag.jsx
 **/